import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigate } from "react-router";
import { Flex } from "@gravity-ui/uikit";
import GameCard from "@/components/ui/GameCard";
import { RoutesList } from "@/router/routesList";
export var GamesList = function (props) {
    var navigate = useNavigate();
    var detailsClickHandler = function (gameId) {
        navigate(RoutesList.Game.getGameDetails(gameId));
    };
    return (_jsx(Flex, { direction: "column", gap: 3, children: props.data.map(function (game) { return (_jsx(GameCard, { game: game, onDetailsClick: detailsClickHandler }, game.id)); }) }));
};
